import { render, staticRenderFns } from "./ProviderAddDialog.vue?vue&type=template&id=96d0ee4e&scoped=true&"
import script from "./ProviderAddDialog.vue?vue&type=script&lang=js&"
export * from "./ProviderAddDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProviderAddDialog.vue?vue&type=style&index=0&id=96d0ee4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d0ee4e",
  null
  
)

export default component.exports